import { gql } from '@apollo/client';

const GET_SHARED_REPORTS_WITH_FDA = gql`
  query GetSharedReportsWithFda($id: Int!) {
    mddapOrgUnitSharedReportWithFda(id: $id) {
      hasSharedDetailedAppraisalData
      hasSharedPerformanceData
    }
  }
`;

export default GET_SHARED_REPORTS_WITH_FDA;
